import React from "react";
import * as icons from "../../icon-components";
/**
 * Icon component will render an SVG component imported from the icons library in the icon-components folder.
 * Using this will ensure the proper size and aria attributes are added.
 * @param IconProps
 * @returns an svg icon loaded as a React component
 */
export const Icon = ({ "data-testid": testId = "icon", src, size = "24px" }) => {
    // eslint-disable-next-line import/namespace
    let SourceComponent = icons[src];
    if (!SourceComponent) {
        SourceComponent = icons.CheckBoxOutline;
    }
    return (React.createElement(SourceComponent, { "data-testid": testId, "data-icon-name": src, height: size, style: { height: size, margin: "0", width: size }, width: size }));
};
